// import { axios } from "@/plugins/axios";

export default {
  install: function(app /*, options*/) {
    app.mixin({
      data: () => ({
        page: {}
      }),
      methods: {
        scrollTop(el) {
          if (!this.isDesktop) {
            el.scrollIntoView();
          }
        }
      }
      // async beforeRouteEnter(to, from, next) {
      //   let page;
      //   try {
      //     page = await axios.get(`/pageContent${to.path}.json`);
      //     console.log(page);
      //   } catch (error) {
      //     page = {};
      //   } finally {
      //     next(vm => (vm.page = page.data));
      //   }
      // }
    });
  }
};
